export const COUNTRY_LIST = { USA: "usa", CANADA: "canada" };
